import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { buildReminderStatus } from "@/lib/reminder";

export const useReminderBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadReminder = async () => {
      try {
        const settingsResponse = await api.get("/reminder-settings");
        const settings = settingsResponse.data;
        if (!settings.enabled) {
          if (isMounted) setStatus(null);
          return;
        }
        const reflectionsResponse = await api.get(`/reflections?period=${settings.frequency}`);
        if (isMounted) setStatus(buildReminderStatus(settings, reflectionsResponse.data));
      } catch {
        if (isMounted) setStatus(null);
      }
    };

    loadReminder();
    return () => {
      isMounted = false;
    };
  }, []);

  return status;
};